<div *ngIf="busy">
  Please wait...
</div>

<div *ngIf="!busy" style="margin: 15px 0;">
  <form [formGroup]="form">

    Ladder:
    <!-- <select [(ngModel)]="ladderId" (ngModelChange)="fetchPlayers($event)"> -->
    <select formControlName="ladderId">
      <option value="">-- select --</option>
      <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.name}} ({{l.ladderId}})</option>
    </select>
    <br /><br />
    <input formControlName="subject" type="text" style="width: 100%;" value="Tennis Ladder Update" />
    <!-- <textarea style="width: 100%" rows="10" formControlName="body"></textarea>
  <div *ngIf="msg" style="background: greenyellow;">
    {{msg}}
  </div> -->
    <button (click)="loadTemplate($event, '423954', 'Tennis Ladder Schedule')">Schedule</button>
    <button (click)="loadTemplate($event, '423933', 'Tennis Ladder Rules')">Rules</button>
    <button (click)="loadTemplate($event, '439384', 'Tennis Ladder Winners')">Winners</button>
    <button (click)="loadTemplate($event, '458605', 'Tennis Ladder Payment')">Payment</button>
    <button (click)="loadTemplate($event, '459332', 'Tennis Ladder Welcome')">Welcome</button>
    <button (click)="loadTemplate($event, '707823', 'Tennis Ladder Coupon')">Coupon</button>
    <div style="min-height: 800px; height: 800px;" id="editor"></div>

    <button (click)="allOff($event)">All Off</button>
    <!--<button (click)="zeroOn($event)">Just 0 On</button>-->
    <button (click)="unpaid($event)">Unpaid</button>
    <div formArrayName="players">
      <table class="table table-bordered table-striped" *ngIf="players.length > 0 ">
        <thead class="thead-dark">
          <tr>
            <th></th>
            <th>Name</th>
            <th>Level</th>
            <th>Paid</th>
            <th>Match Count</th>
          </tr>
        </thead>
        <tbody class="table-striped">
          <tr *ngFor="let p of players.controls; let i=index">
            <ng-container [formGroupName]="i">
              <td width="1%">
                <input type="checkbox" formControlName="selected" /><span style="display: none;">{{playerlist[i].id}}</span>
              </td>
              <td width="97%">{{playerlist[i].getFullName()}}<sup>{{playerlist[i].rank||'N/R'}}</sup></td>
              <td width="1%">{{playerlist[i].levelId}}</td>
              <td width="1%">{{playerlist[i].paid}}</td>
              <td width="1%">{{playerlist[i].matchCount}}</td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <!--{{form.value|json}}-->
  <button (click)="submit($event)" [disabled]="busySend">Send Emails</button>
</div>
